var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaymentRecurrent24 = function SvgPaymentRecurrent24(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "hide",
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27856 10.8895C7.01484 10.959 6.77461 10.7176 6.84616 10.455L7.80728 6.92767C7.87838 6.66672 8.20489 6.57881 8.39793 6.76864L9.12508 7.48371C9.24164 7.59833 9.42126 7.61745 9.56393 7.53743C11.9181 6.21687 14.9397 6.47678 17.0311 8.31715C17.1793 8.44761 17.1789 8.67519 17.0381 8.81364L16.5325 9.31087C16.3945 9.44652 16.1736 9.4453 16.0266 9.3195C14.5574 8.06231 12.5195 7.78928 10.8033 8.50041C10.5826 8.59186 10.5408 8.87591 10.711 9.04328L11.0238 9.35082C11.2192 9.54304 11.1309 9.87442 10.8655 9.94434L7.27856 10.8895Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7215 13.1106C16.9852 13.0411 17.2255 13.2825 17.1539 13.5451L16.1928 17.0724C16.1217 17.3333 15.7952 17.4212 15.6022 17.2314L14.875 16.5163C14.7584 16.4017 14.5788 16.3826 14.4362 16.4626C12.082 17.7832 9.06039 17.5233 6.96902 15.6829C6.82076 15.5524 6.82119 15.3249 6.96198 15.1864L7.46762 14.6892C7.60556 14.5535 7.82648 14.5547 7.97351 14.6805C9.44273 15.9377 11.4806 16.2108 13.1968 15.4996C13.4175 15.4082 13.4593 15.1241 13.2891 14.9568L12.9763 14.6492C12.7809 14.457 12.8692 14.1256 13.1346 14.0557L16.7215 13.1106Z",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "hide",
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 3.75,
    stroke: "currentColor",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaymentRecurrent24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "PaymentRecurrent24.e64f942719496f47f158aebdd6a5a920.svg";